/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EffectiveAnnualCost } from './EffectiveAnnualCost';
import {
    EffectiveAnnualCostFromJSON,
    EffectiveAnnualCostFromJSONTyped,
    EffectiveAnnualCostToJSON,
} from './EffectiveAnnualCost';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfEffectiveAnnualCost
 */
export interface ResultOfEffectiveAnnualCost {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfEffectiveAnnualCost
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfEffectiveAnnualCost
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfEffectiveAnnualCost
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfEffectiveAnnualCost
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfEffectiveAnnualCost
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfEffectiveAnnualCost
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfEffectiveAnnualCost
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {EffectiveAnnualCost}
     * @memberof ResultOfEffectiveAnnualCost
     */
    data?: EffectiveAnnualCost;
    /**
     * 
     * @type {number}
     * @memberof ResultOfEffectiveAnnualCost
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfEffectiveAnnualCost interface.
 */
export function instanceOfResultOfEffectiveAnnualCost(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfEffectiveAnnualCostFromJSON(json: any): ResultOfEffectiveAnnualCost {
    return ResultOfEffectiveAnnualCostFromJSONTyped(json, false);
}

export function ResultOfEffectiveAnnualCostFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfEffectiveAnnualCost {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : EffectiveAnnualCostFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfEffectiveAnnualCostToJSON(value?: ResultOfEffectiveAnnualCost | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': EffectiveAnnualCostToJSON(value.data),
        'Count': value.count,
    };
}

